'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _ActionTypes = require('../actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _FormState = require('MeetingsLib/models/FormState');

var _FormState2 = _interopRequireDefault(_FormState);

var _pick = require('transmute/pick');

var _pick2 = _interopRequireDefault(_pick);

var _keySeq = require('transmute/keySeq');

var _keySeq2 = _interopRequireDefault(_keySeq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = null;

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SET_FORM_STATE, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED, function (state, action) {
  var configuredCustomFormFields = action.payload.customFormFields;

  state = state || new _FormState2.default();
  var validFields = (0, _pick2.default)((0, _keySeq2.default)(configuredCustomFormFields), state.customFormFields);
  return state.set('customFormFields', configuredCustomFormFields.merge(validFields));
}), _defineProperty(_handleActions, (0, _fluxActions.combineActions)(_ActionTypes2.default.RESET_FORM_STATE, _ActionTypes2.default.BOOKING_TIME_CONFLICT), function () {
  return initialState;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/formState.js
// module id = 525
// module chunks = 0